module.exports = "../images/fishing-lure-1@2x.png?v=36d5ee6";